import { useEffect, useState } from "react"
import { PanelLoader } from "../../../../features/ui"
import { useCategoryLoaders } from "../../loaders/categoryLoaders"
import { TableName } from "../../../../tables"
import { ListLoaderWrapper } from "../../../../features/data-types"
import { Category } from "../../state/types"
import { CategoryList } from "./categoryList"
import { BookmarkButton } from "../../../../features/bookmarks"
import { RoutePath } from "../../../../features/routes"

export const Loader = () => {
    const [categories, setCategories] = useState<Category[]>([])
    const [ready, setReady] = useState(false)

    const categoryLoaders = useCategoryLoaders()

    const populate = async () => {
        const { loadAllCategories } = categoryLoaders()
        const data = await loadAllCategories(true)
        setCategories(data)
    }

    useEffect(() => {
        populate().then(() => setReady(true))
    }, [])

    return (
        <PanelLoader
            title="Categorías"
            titleRight={<BookmarkButton routePath={RoutePath.CATEGORIES} />}
            ready={ready}
        >
            <CategoryList categories={categories} />
        </PanelLoader>
    )
}

export const CategoryListLoader = () => (
    <ListLoaderWrapper table={TableName.CATEGORIES}>
        <Loader />
    </ListLoaderWrapper>
)
